export const iconFontAwesomeHouseholdChair = (
	<i className="fa-solid fa-chair"></i>
);
